import(/* webpackMode: "eager" */ "/vercel/path0/web/app/(main)/events/page.tsx");
